<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">
    <div class="content">
      <a class="btn" (click)="generateExcel()">
        <t-icon name="file_download"></t-icon>
        <span class="text">Excel</span>
      </a>
      
      <a class="btn" (click)="generatePowerPoint()">
        <t-icon name="file_download"></t-icon>
        <span class="text">PowerPoint</span>
      </a>
    </div>
  </div>

</div>
<!-- /Toolbar -->
<div class="organigramme"
  [ngClass]="{ dragging: draggingMode !== null }">
  <svg #chartView
    (window:resize)="onResize($event)"
    (body:mousedown)="onMouseDown($event)"
    (body:mousemove)="onMouseMove($event)"
    (body:mouseup)="onMouseUp($event)"
    (wheel)="onMouseWheel($event)"
    [ngStyle]="{ height: viewportHeight + 'px' }">

    <defs>
      <pattern id="small-grid" [attr.width]="gridW" [attr.height]="gridH" patternUnits="userSpaceOnUse">
        <path [attr.d]="gridPath"/>
      </pattern>
      <pattern id="grid" [attr.width]="segmentW" [attr.height]="segmentH" patternUnits="userSpaceOnUse">
        <rect [attr.width]="segmentW" [attr.height]="segmentH" fill="url(#small-grid)"/>
        <path [attr.d]="segmentPath" stroke-width="1"/>
      </pattern>
    </defs>

    <rect class="background"
      [attr.width]="backgroundWidth"
      [attr.height]="backgroundHeight"
      fill="url(#grid)"
      [attr.transform]="'translate(' + backgroundOffsetX + ',' + backgroundOffsetY + ') scale(' + zoom + ')'"/>

    <g #drawings [attr.transform]="'translate(' + offsetX + ',' + offsetY + ') scale(' + zoom + ')'">

      <g 
        *ngFor="let link of links"
        class="connector">
        <polyline
          [attr.points]="link.pointsString"
          (mousedown)="onMouseDown($event, link, 'polyline')" />
        <path class="arrow" d="M5 0 L10 10 L0 10 Z"
            [attr.transform]="'translate(' + link.arrowX + ',' + link.arrowY + ') rotate(' + link.arrowR + ')'" />
        <text
          [attr.x]="link.nameX"
          [attr.y]="link.nameY"
          (mousedown)="onMouseDown($event, link, 'text')">
          {{ link.name }}
        </text>
      </g>

      <g
        *ngFor="let node of nodes"
        [ngClass]="{
          'node-dossier': node.type === 'dossier',
          'node-record': node.type === 'record',
          selected: selectedNode === node,
          'dossier-type-op': node.dossier_type === 'op',
          'dossier-type-ho': node.dossier_type === 'ho',
          'dossier-type-im': node.dossier_type === 'im',
          'dossier-type-at': node.dossier_type === 'at'
        }"
        [attr.transform]="'translate(' + node.x + ',' + node.y + ')'"
        [attr.width]="node.width" [attr.height]="node.height"
        (mousedown)="onMouseDown($event, node)"
        >
        <rect [attr.rx]="node.rx" [attr.ry]="node.ry" [attr.width]="node.width" [attr.height]="node.height" />
        <text [attr.x]="node.width/2" [attr.y]="node.height/2" alignment-baseline="middle" text-anchor="middle">{{ node.name }}</text>
      </g>


      <g *ngIf="selectedNode"
        class="context-menu"
        [attr.transform]="'translate(' + selectedNode.x + ',' + selectedNode.y + ')'">
        
        <g class="add"
          [attr.transform]="'translate(' + (selectedNode.width + 2) + ',-12)'"
          (click)="editedEntity = selectedNode.entity">
          <circle cx="11" cy="12" r="10"/>
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          <title>Ajouter</title>
        </g>

        <g class="delete"
          [ngClass]="{ disabled: nodes.length <= 1 }"
          [attr.transform]="'translate(' + (selectedNode.width + 2) + ',32)'"
          (click)="removeNode(selectedNode)">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          <path d="M0 0h24v24H0z" fill="none"/>
          <title>Supprimer</title>
        </g>

      </g>

    </g>
  </svg>

  <div class="toolbar">
    <a title="Centrer" (click)="centerChart()">
      <t-icon name="filter_center_focus"></t-icon>
    </a>
    <a title="Zoom arrière" (click)="zoomOut()">
      <t-icon name="zoom_out"></t-icon>
    </a>
    <span class="zoom">
      {{ (zoom * 100) | number }}%
    </span>
    <a title="Zoom avant" (click)="zoomIn()">
      <t-icon name="zoom_in"></t-icon>
    </a>
  </div>

  <ul class="legend" title="Légende">
    <li class="dossier-type-op" *ngIf="hasDossierType('op')">Opérationnelle</li>
    <li class="dossier-type-ho" *ngIf="hasDossierType('ho')">Holding</li>
    <li class="dossier-type-im" *ngIf="hasDossierType('im')">Immobilier</li>
    <li class="dossier-type-at" *ngIf="hasDossierType('at')">Autre</li>
  </ul>

  <t-add-node-menu [(entity)]="editedEntity" [currentEntities]="entities"
    [ngClass]="{ closed: !editedEntity }"
    (entitiesAdded)="entitiesAdded($event)">
  </t-add-node-menu>
</div>